<template lang="pug">
    v-card
        model-data-table(
            loading-text="Cargando cuentas corrientes..."
            no-data-text="Sin cuentas corriente."
            no-search
            no-filter
            no-remove
            ref="table"
            v-bind="tableProps"
            v-model="debtItems"
            @detail="submitTableShow"
            )
            template( slot="actions" slot-scope="props" )
                v-btn-action(
                    color="green darken-4"
                    tooltip="Detalle Pago"
                    @click="submitShowPayment(props.item)"
                    v-if="props.item.status==='Pagado'"
                    )
                    v-icon monetization_on
        dialog-detail(
            :invoice-id="select"
            ref="dialog"
            )
        v-dialog(v-model='dialogPayment' width='800')
                v-card
                    model-data-table(
                        loading-text="Cargando pago..."
                        no-data-text="Sin pago."
                        no-search
                        no-filter
                        no-actions
                        ref="table"
                        v-bind="tablePropsPayment"
                        )
</template>

<script>
//
import {
    ModelDataTable,
    VBtnAction,
} from '@/components/reusable_components/next'
import DetailDialog from '@/components/dialogs/invoice/InvoiceDetailDialog'
//
//import SlSaleInvoiceMdl from '@/models/Sale/SlSaleInvoice.js'
import SlCustomerAccountReceivable from '@/models/Sale/SlCustomerAccountReceivable'
import SlCustomer from '@/models/Sale/SlCustomer'
import MdlPosCustomerReceivablePayment from '../../../models/POS/PosCustomerReceivablePayment'
import Filters from '@/views/Customer/tables/customerCurrentAccount/Filters'
import Headers from '@/views/Customer/tables/customerCurrentAccount/Headers'
import { accountPayments } from './headers'
//-
export default {
    props: {
        /**
         * @description
         */
    },
    components: {
        'model-data-table': ModelDataTable,
        'dialog-detail': DetailDialog,
        'v-btn-action': VBtnAction,
    },
    computed: {
        //-
        tableProps() {
            return {
                headers: this.headers,
                filters: this.filters,
            }
        },
        tablePropsPayment() {
            return {
                service: MdlPosCustomerReceivablePayment,
                paramFilter: {
                    sl_customer_receivable_id: this.account_receivable_id,
                },
                headers: this.acHeaders,
            }
        },
    },
    data() {
        return {
            dialog: false,
            dialogPayment: false,
            filters: Filters,
            headers: Headers,
            select: null,
            customerId: null,
            acHeaders: accountPayments,
            account_receivable_id: 0,
            debtItems: [],
            customer: null,
            //props.item.account_receivable.id
        }
    },
    methods: {
        //-
        setCustomerId() {
            this.customerId = this.$route.params.id
        },
        async getCustomer() {
            this.customer = await new SlCustomer().find(this.customerId)
        },
        async getDebts() {
            let response = await new SlCustomerAccountReceivable()
                .where(
                    'sl_customer_account_id',
                    this.customer.sl_customer_account_id
                )
                .include('sl_sale_invoice', 'sl_sale_debit_note')
                // TODO: Define Ordering
                //.orderBy('pay_date')
                .get()
            this.debtItems = response.data.map(d => {
                const debt = d
                const doc = d.sl_sale_invoice
                    ? d.sl_sale_invoice
                    : d.sl_sale_debit_note
                debt.emission_date = doc.emission_date
                debt.number = doc.number
                debt.to_pay = debt.amount - debt.paid_amount
                return debt
            })
        },
        submitTableShow(event) {
            this.select = String(event.item.id)
            this.$refs.dialog.open = true
        },
        submitShowPayment: function(event) {
            this.account_receivable_id = event.account_receivable.id
            this.dialogPayment = true
        },
        async initData() {
            this.setCustomerId()
            await this.getCustomer()
            await this.getDebts()
        },
    },
    beforeMount: async function() {
        await this.initData()
    },
}
</script>
